/**
 * Parses module content from moduleData object
 * Handles cases where content is already parsed, is a string, or doesn't exist
 * @param {Object} moduleData - The module data object
 * @returns {Object} Parsed content object
 */
export default function parseModuleContent(moduleData) {
  if (moduleData?.parsedContent) {
    return moduleData.parsedContent;
  }

  if (!moduleData?.content) {
    return {};
  }

  if (typeof moduleData.content === 'string') {
    try {
      return JSON.parse(moduleData.content);
    } catch {
      return {};
    }
  }

  return moduleData.content;
}
